"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('tag-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M42.1691068,29.2451068 L29.2631068,42.1511068 C28.5878611,42.8271041 27.6715801,43.2069387 26.7161068,43.2069387 C25.7606335,43.2069387 24.8443525,42.8271041 24.1691068,42.1511068 L8,26 L8,8 L26,8 L42.1691068,24.1691068 C43.5649117,25.5732416 43.5649117,27.8409719 42.1691068,29.2451068 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    fill: props.innerStrokeColor,
    cx: "18.5",
    cy: "18.5",
    r: "2.5"
  }))));
});

exports.default = _default;